/** Общий диалог подтверждения действия над аккаунтом (KAN-609, KAN-617). */
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export interface ConfirmView {
  title: string;
  description: string;
  confirm: string;
}

interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  view: ConfirmView;
  onConfirm: () => void;
  testId: string;
  extra?: string | null;
}

export function ConfirmDialog({
  open,
  onOpenChange,
  view,
  onConfirm,
  testId,
  extra,
}: ConfirmDialogProps): JSX.Element {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle>{view.title}</AlertDialogTitle>
          <AlertDialogDescription>
            {extra ? `${extra} ` : ''}
            {view.description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Отмена</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>{view.confirm}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
